// extracted by css-extract-rspack-plugin
export default {"container":"_7194b690","heading":"_2f2e7b7f","description":"_3e1cfe11","button":"_abe04ca1"};